<div [class]="classes">
  <div class="text-md text-gray10-500 font-bold mb-4">
    {{ widget.Title.title }}
  </div>
  <div
    class="text-sm leading-base text-gray30-500"
    [innerHTML]="widget.Description.text"
  ></div>
</div>
